import CanadaFrenchRedirectionBanner from './CanadaFrenchRedirectionBannerContainer';

export default CanadaFrenchRedirectionBanner;
